import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { storage } from "../../config/fbConfig";
import { ref, getDownloadURL } from 'firebase/storage';
import CircularProgress from '../../components/common/CircularProgress';
import './ImageGalleryModal.css'; // Import custom CSS

const ImageGalleryModal = ({ show, handleClose, newsImages, currentIndex }) => {
    const [imageUrls, setImageUrls] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [currentIndexState, setCurrentIndexState] = useState(currentIndex);
    const [error, setError] = useState(null);

    useEffect(() => {
        const loadImageUrls = async () => {
            setIsLoading(true);
            setError(null);
            try {
                const urls = await Promise.all(newsImages.map(async (image) => {
                    const pathAndFile = 'news/' + image;
                    const imageRef = ref(storage, pathAndFile);
                    return await getDownloadURL(imageRef);
                }));
                setImageUrls(urls);
                setIsLoading(false);
            } catch (error) {
                console.error('Error getting download URLs:', error);
                setError('Error loading images');
                setIsLoading(false);
            }
        };

        if (show) {
            loadImageUrls();
        }
    }, [show, newsImages]);

    useEffect(() => {
        setCurrentIndexState(currentIndex);
    }, [currentIndex]);

    const handlePrevious = () => {
        const newIndex = (currentIndexState - 1 + newsImages.length) % newsImages.length;
        setCurrentIndexState(newIndex);
    };

    const handleNext = () => {
        const newIndex = (currentIndexState + 1) % newsImages.length;
        setCurrentIndexState(newIndex);
    };

    const handleCloseProcess = () => {
        handleClose();
    };

    return (
        <Modal show={show} onHide={handleCloseProcess} backdrop="static" keyboard={false} size='lg' className="image-gallery-modal">
            <Modal.Header closeButton>
                <Modal.Title>Image Gallery</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {isLoading ? (
                    <div className="text-center">
                        <CircularProgress />
                    </div>
                ) : error ? (
                    <div className="text-center text-danger">
                        {error}
                    </div>
                ) : (
                    <div className="image-container">
                        <div className="image-wrapper">
                            <img src={imageUrls[currentIndexState]} className="gallery-image" alt="Current" />
                            <div className="image-counter">
                                {currentIndexState + 1} / {newsImages.length}
                            </div>
                            <Button variant="light" className="image-nav prev" onClick={handlePrevious}>
                                &lt;
                            </Button>
                            <Button variant="light" className="image-nav next" onClick={handleNext}>
                                &gt;
                            </Button>
                        </div>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={handleCloseProcess}>
                    OK
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ImageGalleryModal;
